import React from 'react';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import { Row, Col, Input } from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';
import { emailConfigProvider } from '../../../utils/constants';

const ExitEmailForm = (props) => {
  const {
    control,
    errors,
    setValue,
    isUpdate,
    recordTypes = [],
    isLoadingRecordTypes = true,
    provider
  } = props;

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const renderSMTPFields = () => {
    return (
      <>
        <Col md="6" className="mt-3">
          <label className="form-control-label">Host SMTP*</label>
          <Controller
            as={Input}
            control={control}
            type="text"
            name="smtpHost"
            rules={{ required: 'Campo obrigatório' }}
            defaultValue=""
            autocomplete="off"
          />
          <ErrorMessage
            errors={errors}
            name="smtpHost"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="6" className="mt-3">
          <label className="form-control-label">Porta SMTP*</label>
          <Controller
            as={Input}
            control={control}
            type="number"
            name="smtpPort"
            rules={{ required: 'Campo obrigatório' }}
            defaultValue=""
            autocomplete="off"
          />
          <ErrorMessage
            errors={errors}
            name="smtpPort"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </>
    );
  };

  const renderGoogleFields = () => {
    return (
      <>
        <Col md="6" className="mt-3">
          <label className="form-control-label">
            Credenciais da Conta de Serviço* (arquivo JSON)
          </label>

          <Controller
            as={
              <Input
                type="textarea"
                rows="3"
                name="credentialsFile"
                placeholder="Cole aqui o conteúdo do arquivo JSON, obtivo no Google Cloud Platform"
              />
            }
            rules={{
              required: 'Campo obrigatório',
              validate: (value) => {
                return !!value.trim() || 'Campo não pode estar vazio';
              }
            }}
            control={control}
            name="credentialsFile"
            defaultValue=""
          />
          <ErrorMessage
            errors={errors}
            name="credentialsFile"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        {renderSMTPFields()}
      </>
    );
  };

  const renderRecordTypesFields = () => {
    return (
      <Col md="6" className="mt-3">
        <label className="form-control-label">Tipos de registro*</label>
        <Controller
          render={(props) => (
            <FlexSelect
              dataOptions={recordTypes || []}
              isMulti={true}
              value={props.value}
              valueController={setValue}
              fieldName="recordTypeIds"
              labelName="name"
              valueName="id"
              isClearable={true}
              disabled={isLoadingRecordTypes}
              noOptionsMessage={() => 'Nenhum tipo de registro encontrado'}
            />
          )}
          control={control}
          name="recordTypeIds"
          defaultValue=""
          rules={{
            required: 'Selecione pelo menos um tipo de registro',
            validate: (value) => {
              if (!value || !value.length)
                return 'Selecione pelo menos um tipo de registro';
              return true;
            }
          }}
        />
        <ErrorMessage
          errors={errors}
          name="recordTypeIds"
          render={({ message }) => errorFormMessage(message)}
        />
      </Col>
    );
  };

  const renderOthersAndMicrosoftFields = () => {
    return (
      <>
        <Col md="6" className="mt-3">
          <label className="form-control-label">
            Senha{isUpdate ? '' : '*'}
          </label>
          <Controller
            as={Input}
            type="password"
            control={control}
            name="password"
            placeholder=""
            rules={{
              required: isUpdate ? false : 'Campo obrigatório'
            }}
            defaultValue=""
            autocomplete="new-password"
          />
          <ErrorMessage
            errors={errors}
            name="password"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        {renderSMTPFields()}
      </>
    );
  };

  const renderFieldsFromProvider = () => {
    if (provider === emailConfigProvider.GOOGLE) return renderGoogleFields();
    return renderOthersAndMicrosoftFields();
  };

  return (
    <>
      <Row className="mb-3">
        <Col md="6">
          <label className="form-control-label">Nome*</label>
          <Controller
            as={Input}
            control={control}
            type="text"
            name="name"
            rules={{ required: 'O nome é obrigatório' }}
            defaultValue=""
            autocomplete="off"
          />
          <ErrorMessage
            errors={errors}
            name="name"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="6">
          <label className="form-control-label">Email*</label>
          <Controller
            as={Input}
            control={control}
            type="email"
            name="address"
            rules={{ required: 'Endereço é obrigatório' }}
            defaultValue=""
            autocomplete="off"
          />
          <ErrorMessage
            errors={errors}
            name="address"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>

        {renderFieldsFromProvider()}
        {renderRecordTypesFields()}
      </Row>
    </>
  );
};

export default ExitEmailForm;
